import "./FooterStyles.css"

import React from 'react'
import { PiCityFill } from "react-icons/pi";

import { FaCanadianMapleLeaf } from "react-icons/fa";
import { IoIosJournal } from "react-icons/io";
import { SiCoop } from "react-icons/si";
import { SiSecurityscorecard } from "react-icons/si";

import { FaBookmark } from "react-icons/fa6";
import { FaHammer } from "react-icons/fa";
import { FaShieldAlt } from "react-icons/fa";
import { MdGrade } from "react-icons/md";
import { MdDesignServices } from "react-icons/md";
import { FaChalkboardTeacher } from "react-icons/fa";




import { FaHome, FaPhone, FaMailBulk, FaGithub, FaTwitter, FaLinkedin } from "react-icons/fa"

const footer = () => {
  return (
    <div className="footer">
      <div className="footer-container">
        <div className="left">
          <h3 className="footer-title">Professional Experiences</h3>

          <ul className="experience-list">
            <li className="experience-item">
              <FaChalkboardTeacher size={20} className="experience-icon" />
              <span>Teaching Assistant @ Univeristy of Toronto (2025-26)</span>
            </li>
            <li className="experience-item">
              <MdDesignServices size={20} className="experience-icon" />
              <span>Project Assistant @ SciNet HPC (2025)</span>
            </li>
            <li className="experience-item">
              <SiCoop size={20} className="experience-icon" />
              <span>Cyber Analyst @ RBC (2024)</span>
            </li>
            <li className="experience-item">
              <SiSecurityscorecard size={20} className="experience-icon" />
              <span>Cyber Intern @ Doane Grant Thornton (2022–23)</span>
            </li>
          </ul>
        </div>


        <div className="right">
          <h4>"Cybersecurity is much more than a matter of IT."</h4>
          <h5> - Stéphane Nappo, 2018 Global CISO of the year </h5>
          <p className="rbc">I'm passionate about applying engineering design skills to enhance cybersecurity across various sectors — securing safety-critical infrastructure, financial institutions, healthcare clinics, and ultimately, our world.</p>
          <div className="social">
            {/* <a href="https://github.com/charlottepfritz/charlottepfritz">
              <FaGithub size={30} style={{ color: "#ffffff", marginRight: "1rem" }} />
            </a>

            <a href="https://www.linkedin.com/in/charlottepfritz/">
              <FaLinkedin size={30} style={{ color: "#ffffff", marginRight: "1rem" }} />
            </a> */}
            {/* 
            <a href="https://www.oralhealthgroup.com/?s=charlotte+fritz">
              <FaBookmark size={30} style={{ color: "#ffc0cb", marginRight: "1rem" }} />
            </a> */}
          </div>

        </div>

      </div>
    </div >
  )
}

export default footer
